import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { CreateCampaignData } from "../../../types/campaign";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { useEffect, useState } from "react";
import { Button, ButtonProps } from "@mui/material";
import { useStyles } from "./styles";

const GreenButton = styled(Button)<ButtonProps>(({ theme }) => ({
  width: "100%",
  color: "white",
  backgroundColor: "#78BF77",
  "&:hover": {
    filter: "brightness(0.6)",
    backgroundColor: "#78BF77",
  },
}));

const RedButton = styled(Button)<ButtonProps>(({ theme }) => ({
  width: "100%",
  color: "white",
  backgroundColor: "#B02F2F",
  "&:hover": {
    filter: "brightness(0.6)",
    backgroundColor: "#B02F2F",
  },
}));

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  // flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const GridDiv = ({ className = "", style = {}, children }) => (
  <div className={className} style={style}>
    {children}
  </div>
);

export function LinkedCampaign() {
  const styles = useStyles();
  const formik = useFormikContext<CreateCampaignData>();

  const [count, setCount] = useState(0);

  useEffect(() => {
    if (count > 0) {
      formik.validateField("typeCampaign");
    }
    setCount((prev) => prev + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.typeCampaign]);

  const [expanded, setExpanded] = useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const GreenButtonFinal = (props) => (
    <GreenButton
      onClick={() => {
        formik.setFieldValue("typeCampaign", 1);
        setExpanded(false);
      }}
      {...props}
    >
      comprou
    </GreenButton>
  );

  const RedButtonFinal = (props) => (
    <RedButton
      onClick={() => {
        formik.setFieldValue("typeCampaign", 2);
        setExpanded(false);
      }}
      {...props}
    >
      não comprou
    </RedButton>
  );

  return (
    <Stack spacing={4}>
      <Typography color="primary">Campanha vinculada</Typography>
      <Typography variant="subtitle1" gutterBottom>
        <GridDiv className={styles.displayFlexAlignCenter}>
          Você está prestes a criar uma nova camapanha vinculada a{" "}
          <GridDiv className={styles.boxCampaignName}>
            <img
              src={
                "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/murilo-s3/sms1.png"
              }
              alt={"sms icon"}
            />
            {formik?.values?.parentCampaignName}
          </GridDiv>
        </GridDiv>
        <GridDiv>
          Esta campanha só poderá começar após o término da campanha principal.
        </GridDiv>
      </Typography>

      <Typography
        variant="subtitle1"
        gutterBottom
        style={{
          marginTop: "48px",
          ...(!!formik.errors.typeCampaign
            ? { color: "red", fontWeight: "bold" }
            : {}),
        }}
      >
        Selecione um status da campanha principal que será redirecionado.
      </Typography>

      <GridDiv className={styles.accordion}>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            {formik?.values?.typeCampaign === 1 && (
              <GreenButtonFinal sx={{ mr: "4px" }} />
            )}
            {formik?.values?.typeCampaign === 2 && (
              <RedButtonFinal sx={{ mr: "4px" }} />
            )}
            {formik?.values?.typeCampaign === null && (
              <Typography sx={{ mr: "8px" }}>Escolher público</Typography>
            )}
          </AccordionSummary>
          <AccordionDetails>
            <GreenButtonFinal />
            <RedButtonFinal sx={{ mt: "16px" }} />
          </AccordionDetails>
        </Accordion>
      </GridDiv>
    </Stack>
  );
}
